import { render, staticRenderFns } from "./SplitText.vue?vue&type=template&id=3d10a6f4"
import script from "./SplitText.vue?vue&type=script&lang=js"
export * from "./SplitText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports